import { DiscoveryApi } from '../../generated/api';
import configuration from './configuration';

export const discoveryService = new DiscoveryApi(configuration);
